import moment from "moment";
import { lowerCaseRemoveSpace } from "helpers/utils";
import { ExtendedSymptomData } from "pages/symptoms/SymptomsModal";

export const lightheadednessMapper = ({
  filteredExtendedSymptomData,
  mapperType,
  mapperValue,
  multiChoiceTooltip
}: {
  filteredExtendedSymptomData: ExtendedSymptomData[] | null;
  mapperType?: string | undefined;
  mapperValue?: string | number | undefined;
  multiChoiceTooltip?: string | undefined;
}) => {
  const frequency: [string, number, string][] = [];
  const severity: [string, number, string, string][] = [];

  const sortedData = filteredExtendedSymptomData?.sort(
    (a, b) => moment(a.timestamp).valueOf() - moment(b.timestamp).valueOf()
  );

  if (mapperType) {
    let tooltipValue = "";
    if (lowerCaseRemoveSpace(mapperType) === "frequency") {
      switch (mapperValue) {
        case 1:
          tooltipValue = "Rarely (1-3 times)";
          break;
        case 4:
          tooltipValue = "Occasionally (4-7 times)";
          break;
        case 7:
          tooltipValue = "Frequently (8-15 times)";
          break;
        case 10:
          tooltipValue = "Nearly everyday";
          break;
      }
    } else if (lowerCaseRemoveSpace(mapperType) === "severity") {
      tooltipValue = multiChoiceTooltip ? multiChoiceTooltip : "";
    }
    return tooltipValue;
  }

  sortedData?.forEach(item => {
    item.data?.map(item2 => {
      const lowerCaseValue = item2?.value?.toLowerCase().replace(/\s/g, "");
      if (lowerCaseRemoveSpace(item2?.key) === "frequency") {
        let value = 0;
        switch (lowerCaseRemoveSpace(item2?.value)) {
          case "rarely(1-3times)":
            value = 1;
            break;
          case "occasionally(4-7times)":
            value = 4;
            break;
          case "frequently(8-15times)":
            value = 7;
            break;
          case "nearlyeveryday":
            value = 10;
            break;
        }
        frequency.push([
          String(moment(item.timestamp).valueOf()),
          value,
          "Frequency"
        ]);
      } else if (lowerCaseRemoveSpace(item2?.key) === "severity") {
        let value = 0;

        if (lowerCaseValue.includes("feelingofspinningormovement")) {
          value = 1;
        }
        if (lowerCaseValue.includes("unsteadinessgettinguporwalking")) {
          value = 3;
        }
        if (lowerCaseValue.includes("feelingdistantorfoggy")) {
          value = 5;
        }
        if (lowerCaseValue.includes("visionimpairment/greyingout")) {
          value = 7;
        }
        if (lowerCaseValue.includes("nearpassingout")) {
          value = 8;
        }
        if (lowerCaseValue.includes("lossofconsciousness")) {
          value = 10;
        }
        severity.push([
          String(moment(item.timestamp).valueOf()),
          value,
          "Severity",
          item2.value
        ]);
      }
    });
  });

  return [frequency, severity];
};
